export function price(value, rate, selectedTerm) {
  //value: Saldo a ser financiado
  //rate: Taxa de Juros utilizada
  //selectedTerm: Quantidade de Parcelas

  const r = rate ? rate / 100 : 0; // Convertendo a taxa para decimal
  const n = selectedTerm;
  let payment;
  if (n === 0) {
    payment = 0;
  } else {
    if (rate === 0 && n !== 0) {
      payment = value / n;
    } else {
      payment = (value * r) / (1 - Math.pow(1 + r, -n));
    }
  }
  return payment;
}
